import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  routePermissions,
  learnLibrary,
  learnLearningPath,
  learn,
  learnLearningPathListView
} from "../../routes/LearningCenterRoutes";
import LearningCenterLearningPath from "./LearningCenterLearningPath";
import LearningCenterLibrary from "./LearningCenterLibrary";

const LearningCenterLearn = () => {
  const userPermissions = useSelector(
    state => state.userState.user.permissions
  );
  return (
    <>
      {userPermissions && userPermissions[routePermissions.learnLearningPath] && (
        <>
          <Route
            exact
            path={learn}
            render={() => <Redirect to={learnLearningPathListView} />}
          />
          <Route
            exact
            path={learnLearningPath}
            render={() => <Redirect to={learnLearningPathListView} />}
          />
          <Route
            path={learnLearningPath}
            component={LearningCenterLearningPath}
          />
        </>
      )}
      {userPermissions && userPermissions[routePermissions.learnLibrary] && (
        <Route path={learnLibrary} component={LearningCenterLibrary} />
      )}
    </>
  );
};

export default LearningCenterLearn;
